import { GetBrazeEventPropertiesArgs } from 'types/api/arguments/get-braze-event-properties-args'
import { GetBrazeEventPropertiesResp } from 'types/api/response/get-braze-event-properties-resp'

import { api } from './api'

export const getBrazeEventProperties = ({ eventName, modelId }: GetBrazeEventPropertiesArgs) =>
  api.get<GetBrazeEventPropertiesResp>('/external_crm/event_payload', {
    params: {
      event_name: eventName,
      model_id: modelId,
    },
  })
